import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import getContentUrl from "@/utils/getContentUrl";

const getHref = (props: { url?: string; header_url?: string }) => {
  const isAbsoluteUrlRe = /^(http|https)/;
  if (isAbsoluteUrlRe.test(props?.url ?? "")) {
    return props?.url;
  } else {
    return getContentUrl(props) || `${MONOLITH_ORIGIN}${props?.header_url}`;
  }
};

export default getHref;
